import './src/styles/index.scss';
import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;
